var harkTrigger = document.querySelectorAll("[data-hark-trigger]");
var harkContactButton = document.querySelector("#hark_contact_button");

if (harkContactButton) {
  const harkScript = document.createElement("script");
  harkScript.src =
    "https://storage.googleapis.com/prod_harks/sendhark_handler.js?randomstr=" +
    Date.now();
  document.body.appendChild(harkScript);

  harkScript.onload = function () {
    harkEmbedJs.init(
      "661952dc4c762cf386fc2f92",
      "popup",
      "hark_contact_button"
    );
  };

  if (harkTrigger.length > 0) {
    harkTrigger.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        harkContactButton.click();
      });
    });
  }
}
